//import React from 'react';
/*
https://obfuscator.io/
https://beautifier.io/
*/

import ic from './ic';
import ff from './ff';
import bf from './bf';
import ce from './ce';
import cf from './cf';

import { 
  View, 
  ScrollView,
} from 'react-native'; // react-native-web の場合は iOS で error が発生


export default class cr { // common function
    
static myCB_call_tree = (pd={
  b_ect: false, // execute
  ctr: 'slc/iud',
  dd_prtss: {},
  dd_elmDefss: {
    als: { // alias
      elm: '',
      n_dms: 2, // slc
      cnd: '',
      o_cnd: _dd_prtss => '',
      dd_cldDefss: { // same with dd_elms
      },
      o_atr: () => {} // after
    },
  },
  dd_cashss: {},
  state: '',
  od_fmts: _d_dats => {},
  b_vsn: true,
  b_ltt: false,
}) => new Promise( async _o_end1 => {

  let _fst = null;

  if (pd.op_bfrAll) {
    let _b = await pd.op_bfrAll();
    if ( _b == false) _o_end1(null);
  };

  let _dd_cashss = pd.dd_cashss ?? {};
  let _b_vsn = pd.b_vsn ?? false;
  let _b_ltt = pd.b_ltt ?? false;
  
  const _o_slc = (pd2={
    als: '', // alias
    dd_prtss: {},
    d_defs: {},
    ld_arsss: [], // address
  }) => new Promise( async _o_end3 => {

    let _elm = pd2.d_defs.elm ?? pd2.als;

    let _cnd = pd2.d_defs.cnd ?? pd2.d_defs.o_cnd(pd2.dd_prtss ?? {});
    if (ic.gb_dbg) ff.l('cr 61: {}'.f(_cnd))
    //ff.l('cr 63: {}, {}'.f(_cnd));

    cf.myCB_call_slc({ // call_tree で _vsn = _ltt を設定するだけでは、call_slc の dd_rfrss に伝わらない
      elm: _elm,
      n_dms: 3, // 大前提
      cnd: _cnd,
      dd_rfrss: pd2.d_defs.dd_rfrss ?? {},
      ld_sortss: pd2.d_defs.ld_sortss ?? null,
      dd_cashss: _dd_cashss,
      d_insFlds: pd2.d_defs.d_insFlds,
    })
    .then( async _a_rs => {

      let _n_lmt = pd2.d_defs.n_lmt ?? -1; // 指定がなければ無制限

/*
      let _ld_elmss = 
        ff.f(_a_rs) ? 
          _a_rs
        : pd2.d_defs.d_insFlds ?
          [ff.myCM_copy(pd2.d_defs.d_insFlds)]
        : [];
ff.l('83: {}, {}, {}'.f(pd2.als, _ld_elmss, pd2.d_defs.d_insFlds))
*/

//      _ld_elmss = _ld_elmss
      let _ld_elmss = _a_rs
      .map( (_d_rs, _idx) => {
        let _d_dats =  bf.c({ 
          elm: _elm,
          key: _d_rs._key ?? -1,
          idx: _idx,
          d_flds: _d_rs,
          dd_stgss: {},
          b_upd: false,
          b_new: false,
//          b_dlt: false,
          b_dlt: (_d_rs[`${_elm}cz1i`] != 0) ? false : true, // 削除データを呼び込んだ場合への対応
          b_show: (_n_lmt == -1 || _idx < _n_lmt) ? true : false ,
          b_dlyCld: (pd2.d_defs.b_dlyCld) ? true : false, // child を遅延読込する場合、初期表示では必ず子要素を隠す
          b_hideCld: (pd2.d_defs.b_dlyCld) ? true : false, // child を遅延読込する場合、初期表示では必ず子要素を隠す
          dld_cldDatsss: {},
          ld_arsss: bf.c(pd2.ld_arsss ?? [], [{als: pd2.als, key: _d_rs._key}])
        }, (pd2.d_defs.od_inis) ? pd2.d_defs.od_inis(_d_rs) : pd2.d_defs.d_inis); // elm 混在時は od_inis で b_new を切り替え
        return (pd2.d_defs.od_fmts) ? pd2.d_defs.od_fmts(_d_dats) : _d_dats;
      }) ?? [];

      for await ( let [_idx, _d_elms] of bf.e(_ld_elmss)) { // ポインタが変更されないよう注意
        let _dd_prtss = bf.c(pd2.dd_prtss ?? {}, {[pd2.als]:_d_elms}); // d_flds がないと immer でエラー発生
        if (pd2.d_defs.op_act) await pd2.d_defs.op_act(_dd_prtss)
        if (bf.f(pd2.d_defs.dd_cldDefss) == true) { // cld が存在する場合の処理
          for await (let [_idx2, _cld] of bf.e(pd2.d_defs.dd_cldDefss)) {
            let _d_cldDefs = pd2.d_defs.dd_cldDefss[_cld];

            if (pd2.d_defs.b_dlyCld ?? false) { // 遅延読込の場合
              _d_elms.dld_cldDatsss[_cld] = {
                op_callDlySlc: () => new Promise( _o_end6 => {
                  _o_slc({
                    als: _cld,
                    dd_prtss: _dd_prtss,
                    d_defs: _d_cldDefs,
                    ld_arsss: _d_elms.ld_arsss,
                  })
                  .then( _a_rs2 => {
                    _o_end6(_a_rs2);
                  });
                }),
              };
            }
            else { // 遅延読込でない場合
              await _o_slc({
                als: _cld,
                dd_prtss: _dd_prtss,
                d_defs: _d_cldDefs,
                ld_arsss: _d_elms.ld_arsss,
              })
              .then( _a_rs2 => {
                _d_elms.dld_cldDatsss[_cld] = _a_rs2;
              });
            };
          }
        }
      }

      _o_end3(_ld_elmss);

    });
  });

  const _o_iud = (pd2={
    als: '',
    d_elmDefs: {
      od_insDats: d_dats => {},
      o_updCnd: d_dats => {},
    },
    ld_datss: [
      {}
    ],
    b_root: false,
  }) => new Promise( async _o_end2 => {

    if (bf.f(pd2.ld_datss) == false ) _o_end2(); // 空白は対象外

    let _d_elmDefs = bf.c({
      b_setPageKey: false,
      od_insDats: null,
      o_updCnd: null,
      dd_cldDefss: null,
      pntKeyFld: null,
    }, pd2.d_elmDefs);

//ff.l('cr 173: {}, {}, {}'.f(pd2.als, pd2.ld_datss, pd2));
    ff.myCM_srl(pd2.ld_datss.map( (_d_dats, _idx) => () => new Promise( _o_end5 => { // DB 負荷を低減

      _d_dats = bf.c({
        elm: pd2.als,
        b_upd: true,
        b_new: true,
        b_dlt: false,
        dd_stgss: {},
      }, _d_dats)

      new Promise( async _o_end3 => {
        if ( 
          _d_dats.b_dlt != true && 
          (
            (_d_dats.b_upd == true && _d_dats.b_new == true) || _b_vsn == true
          ) // 暦管理は子要素を含め必ず追加
        ) { // ins

          let _elm = _d_elmDefs.elm ?? _d_dats.elm;

          new Promise( async _o_end4 => { // 既存データの存在チェック
            if (_d_elmDefs.o_insCnd) {
              let _cnd = _d_elmDefs.o_insCnd({
                ...pd2.dd_prtss, 
                [pd2.als]: _d_dats
              });
              await cf.myCB_call_slc({
                elm: _elm,
                n_dms: 3,
                cnd: _cnd,
                dd_rfrss: null,
                ld_sortss: null,
                dd_cashss: null,
              })
              .then( _a_rs => {
                if (bf.f(_a_rs) == false) _o_end4(true);
                _o_end4(false);
              });
            }
            else {
              _o_end4(true);
            }
          })
          .then( async _b_res => {
            if (_b_res == false)
              _o_end3(_d_dats);
            let _d = _d_elmDefs.od_insDats(
              bf.c(pd2.dd_prtss, {[pd2.als]: _d_dats}),
            );          
            if (bf.f(_d)) {
              _d = bf.c({ // テーブル定義必須
//                [`${_elm}b21f`]: (pd2.b_fnd != true) ? (global.t?.state.sgcd_cmnStgs.c20r_fst ?? -1) : null,
                [`${_elm}cx1i`]: 9999,
                [`${_elm}cy1t`]: ff.myDT_getNow() ?? '',
//                [`${_elm}cy1f`]: global.t?.state.sgcd_cmnStgs.c10r_fst ?? -1,
                [`${_elm}cy1f`]: global.t?.state.sgcd_cmnStgs.c10r_key ?? -1, // c10r は歴管理の対象外
//                [`${_elm}cz1i`]: 10,
                [`${_elm}cz1i`]: _d_dats.d_flds[`${_elm}cz1i`] ?? 10,
              }, _d);
              if (_d_elmDefs.b_fnd != true) {
                _d = {
                  [`${_elm}b21f`]: global.t?.state.sgcd_cmnStgs.c20r_fst ?? -1,
                  ..._d
                }
              };
              if ( _b_vsn ) _d = bf.c(_d, { _fst: _d_dats.d_flds._fst ?? -1 })
//ff.l('cr 234: {}'.f(_d));
              await cf.myCB_call_iud({
                ctr: 'ins',
                elm: _elm, // elm混在を考慮
                d_vals: _d,
              })
              .then( async _res => {
                _d_dats.d_flds = { ..._d_dats.d_flds, ..._d, ..._res[0]};
                if (_d_elmDefs.b_setPageKey) {
                  if ( _b_vsn == true) { // 歴管理
                    _fst = (_d_dats.d_flds._fst <= 0) ? _res[0]._key : _d_dats.d_flds._fst;
                    await global.t.setState({
                      sgc_pageKey: _res[0]._key,
//                      sgc_pageFst: (_d_dats.d_flds._fst <= 0) ? _res[0]._key : _d_dats.d_flds._fst,
                      sgc_pageFst: _fst,
                    });
                  }
                  else {
                    await global.t.setState({
                      sgc_pageKey: _res[0]._key,
                    });
                  };
                };
                if ( _b_vsn == true) { // 歴管理
                  let _l_qrys = [
                    `
                      UPDATE
                        t_${_elm}
                      SET 
                        _fst = _key
                      WHERE
                        t_${_elm}._key = ${_res[0]._key}
                        AND _fst = -1;
                    `, // 削除データを含む、古い順にデータが登録されている前提
                    `
                      UPDATE
                        t_${_elm}
                      SET 
                        _vsn=(
                          SELECT
                            COUNT(*)
                          FROM
                            t_${_elm} AS A
                          WHERE
                            A._fst = t_${_elm}._fst
                            AND A._key <= t_${_elm}._key
                        )
                      WHERE
                        t_${_elm}._key = ${_res[0]._key}
                    `, // 削除データを含む、古い順にデータが登録されている前提
                    `
                      UPDATE
                        t_${_elm}
                      SET 
                        _ltt = (
                          SELECT
                            MAX(_vsn)
                          FROM
                            t_${_elm} AS A
                          WHERE
                            A._fst = t_${_elm}._fst
                        )
                      WHERE
                        t_${_elm}._fst = (
                          SELECT
                            _fst
                          FROM
                            t_${_elm} AS A
                          WHERE
                            A._key = ${_res[0]._key}
                        )
                    `
                  ];
                  await cf.myCB_call_iud({
                    ctr: 'qrys',
                    elm: _elm,
                    l_qrys: _l_qrys,
                  });
                };
                if (_d_elmDefs.op_atrIns) await _d_elmDefs.op_atrIns(_d_dats); // 後処理
                if (_d_elmDefs.op_atrUpd) await _d_elmDefs.op_atrUpd(_d_dats); // 後処理
                _o_end3(_d_dats);
              })
            }
            else {
              _o_end3(_d_dats);
            };
          })
        }
        else if ( 
          _d_dats.b_dlt != true && 
          (
            (_d_dats.b_upd == true && _d_dats.b_new == false) && _b_vsn != true
          )
        ) { // upd
          let _elm = _d_elmDefs.elm ?? _d_dats.elm;
          let _d = {};
          Object.keys(_d_dats.dd_stgss)
          .filter( _fld => 
            (bf.f(_d_elmDefs.elm) == false && String(_fld).substr(0,4) == _d_dats.elm) ?
              true
            : (bf.f(_d_elmDefs.elm) && _d_elmDefs.elm == String(_fld).substr(0,4)) ? 
              true
            : false
          ) // elm 混在を考慮 
          .map( _fld => {
            if (_d_dats.dd_stgss[_fld].b_chg == true) {
              _d[_fld] = _d_dats.d_flds[_fld];
            }
          });
          let _cnd = 
            (_d_elmDefs.o_updCnd) ?
              _d_elmDefs.o_updCnd(
                bf.c(pd2.dd_prtss, {[pd2.als]: _d_dats})
              )
            : // 初期値
              `_key = {}`.f(
                (bf.f(_d_elmDefs.elm) && _d_elmDefs.elm != _d_dats.elm) ?
                  _d_dats.d_flds['{}_key'.f(_d_elmDefs.elm)]
                : _d_dats.d_flds._key // elm 混在を考慮
              )
          ;            
          if (bf.f(_d)) { // elm 混在を考慮
            _d = bf.c({ // テーブル定義必須
              [`${_elm}cy1t`]: ff.myDT_getNow() ?? '',
              [`${_elm}cy1f`]: global.t?.state.sgcd_cmnStgs.c10r_fst ?? -1,
            }, _d);
            await cf.myCB_call_iud({
              ctr: 'upd',
              elm: _elm, // elm混在を考慮
              d_vals: _d,
              cnd: _cnd,
            })
            .then( async () => {
              if (_d_elmDefs.op_atrUpdFld) {
                for await (let [_idx, _fld] of ff.e(_d)) { // 更新された項目のみが処理対象
                  await _d_elmDefs.op_atrUpdFld(_fld, _d_dats); // 後処理
                };
              } 
              if (_d_elmDefs.op_atrUpd) await _d_elmDefs.op_atrUpd(_d_dats); // 後処理
              _o_end3(_d_dats);
            })
          }
          else {
            _o_end3(_d_dats);
          }
        }
        else if (
          _d_dats.b_dlt == true && _d_dats.b_new != true && _b_vsn != true // 歴管理への対応
        ) { // dlt
          let _elm = _d_elmDefs.elm ?? _d_dats.elm;
          let _d = {
            [`${_elm}cz1i`]: 0, // elm 混在を考慮
          };
          _d = bf.c({ // テーブル定義必須
            [`${_elm}cy1t`]: ff.myDT_getNow() ?? '',
            [`${_elm}cy1f`]: global.t?.state.sgcd_cmnStgs.c10r_fst ?? -1,
          }, _d);
          let _cnd = 
            (_d_elmDefs.o_updCnd) ?  // elm 混在時は o_updCnd 必須
              _d_elmDefs.o_updCnd(
                bf.c(pd.dd_prtss, {[pd2.als]: _d_dats}),
              )
            : // 初期値
              `_key = {}`.f(
                (bf.f(_d_elmDefs.elm) && _d_elmDefs.elm != _d_dats.elm) ?
                  _d_dats.d_flds['{}_key'.f(_d_elmDefs.elm)]
                : _d_dats.d_flds._key // elm 混在を考慮
              )
          ;            
          await cf.myCB_call_iud({
            ctr: 'upd',
            elm: _elm, // elm混在を考慮
            d_vals: _d,
            cnd: _cnd,
          })
          .then( () => {
            _o_end3(_d_dats);
          })
        }
        else { // スルー（＝子要素のみの変更）の場合を考慮
          _o_end3(_d_dats);
        }
      })
      .then( async _d_dats2 => { 
        let _dd_prtss = bf.c(pd2.dd_prtss, {[pd2.als]: _d_dats2})
        if ( _d_elmDefs.dd_cldDefss ) { // 子要素の処理
          await ff.myCM_srl(Object.keys(_d_elmDefs.dd_cldDefss).map( (_als, _idx2) => () => new Promise( async _o_end4 => {
            if (
              _d_dats.dld_cldDatsss && 
              _d_dats.dld_cldDatsss[_als]
            ) {
              await _o_iud({
                als: _als,
                d_elmDefs: _d_elmDefs.dd_cldDefss[_als],
                ld_datss: _d_dats.dld_cldDatsss[_als],
                dd_prtss: _dd_prtss,
                b_root: false,
              })
            }
            _o_end4();
          })));
        }
        if (_d_elmDefs.op_atrCld) {
          await _d_elmDefs.op_atrCld(_d_dats2); // 子要素処理後、負荷が高く競合が起こりやすいため 原則は op_atrUpd を使用
        };
        _o_end5();
      })
      .catch( _err => {
      })
    })))
    .then(() => {
      _o_end2();
    });
  });

  if (pd.b_ect == false) {
    _o_end1(); // b_ect == false は実行対象外
  }
  else {
    if (bf.i(pd.ctr, ['slc'])) {

      let _d_rs = {};
      for await (let [_idx, _als] of ff.e(pd.dd_elmDefss)) {
        await _o_slc({
          als: _als,
          dd_prtss: pd.dd_prtss || {},
          d_defs: pd.dd_elmDefss[_als],
        })
        .then( _a_rs => {
          _d_rs[_als] = _a_rs;
        });
      }
      new Promise( _o_end2 => {
        if ( bf.f(pd.state) == true ) {
          global.t?.setState({
            [pd.state]: _d_rs,
          }, () => {
            _o_end2();
          });
        }
        else {
          _o_end2();
        };
      })
      .then(() => {
        if (pd.op_atrAll) { // 事後処理
          pd.op_atrAll(_d_rs)
          .then(() => {
            _o_end1(_d_rs);
          });
        }
        else{
          _o_end1(_d_rs);
        };
      });

    }

    if (bf.i(pd.ctr, ['iud'])) {

      ff.myCM_srl(Object.keys(pd.dd_elmDefss).map( (_als, _idx) => () => new Promise( async _o_end2 => {
        await _o_iud({
          als: _als,
          d_elmDefs: pd.dd_elmDefss[_als],
          ld_datss: global.t?.state[pd.state][_als],
          dd_prtss: {},
          b_root: true,
        })
        _o_end2();
      })))
      .then( async () => {
        if (pd.op_atrAll) {
          await pd.op_atrAll();
        }
        _o_end1(_fst);
      });
    };
  }

});

static InpTree = (pd={
  b_vsb: true,
  b_edit: true,
  state: '', // dld_datsss
  dd_elmDefss: {} // ddd_defsss
}) => { // inputs

  if (pd.b_vsb == false) return null; // b_vsb == false の場合は非表示

  if (bf.f(global.t?.state[pd.state]) == false) return null;

  const _get_dat = (pdld_datsss, pld_adrss, pb_prt=false) => { // pld_elmTreess において pl_pntIdxs/pn_datIdx で指定された dat を取得する
    let _ld_adrss = pld_adrss;
    if ( pb_prt && bf.f(_ld_adrss) ) _ld_adrss = _ld_adrss.slice(0,-1); // 親要素を取得する場合
    if ( bf.f(_ld_adrss) == false || bf.f(pdld_datsss) == false) {
      return pdld_datsss;
    }
    else {
      let _d_dats = _ld_adrss.reduce( ( _prev, _d_adrs ) => {
        if ( _prev == null ) {
          return pdld_datsss[_d_adrs.als][_d_adrs.idx];
        }
        else {
          return _prev.dld_cldDatsss[_d_adrs.als][_d_adrs.idx];
        };
      }, null);
      return _d_dats;
    };
  };

  const _chkNoCld = pdld_cldDatsss => {
    return Object.keys(pdld_cldDatsss)
    .reduce( ( _prev, _als ) => {
      if ( _prev == false ) return false;
      if ( bf.f(pdld_cldDatsss[_als]) == true ) return false;
      return true;
    }, true);
  };

  const _od_elmDefsIni = (pd={
    elm: '',
    b_frm: false,
  }) => ({
    elm: pd.elm,
    pfx: '',
    b_vsb: true,
    ob_vsb: null, // b_newLine に影響
    b_edit: true,
    b_row: false,
    b_hideOnNoCld: false,
    b_lyr: true, // 段差の有無
    od_insDats: null, // (_d_flds, _d_dats) => ({}),
    dd_fldDefss: null,
    dd_cldDefss: null,        
    ld_sortss: null,
    b_newLine: false,
    d_chks: {
      b_vsb: false,
      b_edit: false,
      ob_edit: null,
      b_iniHdr: false,
      b_iniVal: false,
    },
    b_hzl: false, // horizontal list
    b_ttl: true,
    stlCta: null,
    o_stlCta: null,
    b_zbr: false,
    d_btns: {
      b_vsb: false,
      o_onPrs: null,
    },
  }); 

  const _od_fldDefsIni = (pd={
  }) => ({ // 初期値
    type: '', // Inp, Pck
    b_vsb: true,
    b_edit: (bf.i(global.t?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
    b_hdrPrs: false,
    btnIconName: 'plus',
    b_btnPrs: false,
    onBtnPrs: null,
    b_dltPrs: false,
    ini: '',
    pfx: '',
    sfx: null,
    o_sfx: null,
    phd: '',
    ld_iss: [],
    b_mln: false,
    stlCta: null,
    stlInp: null,
    stlLbl: null,
    n_col: null,
    n_sort: 1,
    b_tail: true,
    aln: null,
  });

  const _od_insDatsIni = (pd={
    elm: '',
  }) => ({
    elm: pd.elm,
    key: null,
    idx: null,
    d_flds: {}, // _KEY が null の場合に 新規登録と判定するため _KEY に初期値を設定しないこと
    dd_stgss:{},
    b_upd: false,
    b_new: true, // b_new = true かつ b_upd = true が ins 対象 ( b_new のみで判断した場合、空白行も登録されてしまう )
    b_dlt: false,
    b_hideCld: false, // 速度への影響を考慮し、基本、隠したいが、開発しずらくなるので、false
    dld_cldDatsss: null,
    dd_prtss:{},                                    
    b_chk: false,
  });


  const _o_rdrHdr = (pd2={
    als: null, // 20211126
    d_elmDefs: {},
    n_lyr: 1,
    b_dly: false,
    l_alss: null, // 20211126
  }) => { // render header

    let _n_lyr = pd2.n_lyr ?? 0;

    let _l2 = [];
    if (pd2.d_elmDefs.dd_fldDefss) Object.keys(pd2.d_elmDefs.dd_fldDefss)
    .map( ( _fld, _fldIdx ) => { // fld ごとの処理

      let _d_fldDefs = bf.c(
        _od_fldDefsIni({}),
        pd2.d_elmDefs.dd_fldDefss[_fld]
      ); 

      let _o = ce.c(ce.Lbl, {
        key: 'InpTree.Hdr.Fld.{}'.f(_fldIdx), 
        pfx: _d_fldDefs.pfx, 
        n_col: _d_fldDefs.n_col, 
        d_stlCtas: {
          marginTop: 0,
          marginBottom: 0,
          ..._d_fldDefs.d_stlLbls,
        },
      });

      if (_d_fldDefs.d_hdrs) {
        _l2.push(
          ce.c(View, {
            key: _fldIdx,
            style: {
              width: _d_fldDefs.d_hdrs.n_w,
              height: _d_fldDefs.d_hdrs.n_h,
              flexDirection: 'row',
              justifyContent: 'flex-start',
              alignItems: 'center',
            },
          }, [_o])
        );
      }
      else { // セル指定なし
        _l2.push(_o);
      };

    });

    let _l = [];
    _l.push([
      ce.c(View, {
        key: 'InpTree.Hdr',
        style: {
          flexDirection: 'row',
          justifyContent: 'flex-start',
          alignItems: 'flex-start',
          ...pd2.d_elmDefs.stlCta, // 廃止予定
          ...pd2.d_elmDefs.d_stlHdrRows,
        },
      }, [
        (pd2.d_elmDefs.b_lyr != false) ? // 通常は段差を表示
          ce.c(View, {
            key: -1,
            style: {
              width: _n_lyr * ic.gn_fontSizeNrm,
            },
          })
        : null,

        (pd2.b_dly == true && pd2.d_elmDefs.b_subHdr != true) ? // 上手い方法を検討要
          ce.c(View, {
            key: -2,
            style: {
              width: ic.gn_iconSizeSml + ic.gn_mgnSml * 2,
            },
          })
        : null,

        ce.c(View, { // View が 2層でないと改行がおきない
          key: -3,
          style: {
            flex: 1,
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
          },
        }, [
          ce.c(View, {
            key: -1,
            style: {
              flexDirection: 'row',
              justifyContent: 'flex-start',
              alignItems: 'flex-start',
            }
          }, [
            (pd2.d_elmDefs.d_chks?.b_vsb == true && pd2.d_elmDefs.d_chks?.b_hdr != false) ? // チェックボックスを表示する場合
              ce.c(ce.Chk, { 
                key: -1,
                stlCta: {
                  width: ic.s(2),
                },
                b_val: pd2.d_elmDefs.d_chks?.b_iniHdr ?? false,
                o_onChg: _b_val => {
                  global.t?.setState({ // 20211126
                    [pd.state] : bf.p(global.t?.state[pd.state], _next => {
                      let _ld_datss = cf.myRN_getDatByAls(_next, pd2.l_alss ?? [pd2.als]);
                      _ld_datss
                      .map( _d_dats => {                            
                        if (
                          !pd2.d_elmDefs.d_chks?.ob_edt ||
                          ( pd2.d_elmDefs.d_chks?.ob_edt && pd2.d_elmDefs.d_chks?.ob_edt(_d_dats) == true)
                        ) {
                          _d_dats.b_chk = _b_val;
                        }
                      })
                    }),
                  }, () => {
                    if (pd2.d_elmDefs.d_chks.o_onChg) pd2.d_elmDefs.d_chks.o_onChg({ ..._d_dats, b_chk: _b_val });
                  });
                },
              }, [])
            : (pd2.d_elmDefs.d_chks?.b_vsb == true && pd2.d_elmDefs.d_chks?.b_hdr == false) ? // チェックボックスを表示する場合
              ce.c(View, {
                key: -1,
                style: {
                  width: ic.s(2),
                },
              })
            : null,
            ce.c(View, {
              key: -2,
              style: [{
                flex: 1,
                flexDirection: 'row',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                flexWrap: 'wrap',
              }, pd2.d_elmDefs.stlCta],
            }, _l2),
          ]),
        ]),

      ]),
    ]);

    if ( pd2.d_elmDefs.dd_cldDefss ) { // 子要素の処理 遅延読込は対象外
      Object.keys(pd2.d_elmDefs.dd_cldDefss)
      .map( ( _als ) => { // fld ごとの処理

        let _d_cldDefs = bf.c(
          _od_elmDefsIni({ // 初期値の定義
            elm: _als,
            b_frm: pd2.d_elmDefs.dd_cldDefss[_als].b_frm ?? false
          }), 
          pd2.d_elmDefs.dd_cldDefss[_als] || {}
        ); 

        if ( pd2.d_elmDefs.b_dlyCld != true && _d_cldDefs.b_rootHdr == true) {
          _l.push(_o_rdrHdr({
            als: _als, // 20211126
            d_elmDefs: _d_cldDefs,
            n_lyr: _n_lyr + 1,
            b_dly: pd2.b_dly,
            l_alss: bf.c(pd2.l_alss ?? [pd2.als], [_als]) // 20211126
          }))
        };
      });
    }

    return _l;
  };

  const _rdr_tree = (pd2={ // render tree
    als: '', // alias
    d_elmDefs: {}, // ddd_defsss[_als],
    ld_elmDatss: [], // dld_datsss[_als],
    ld_adrss: [], // set automatically
    n_lyr: 1, // set automatically
  }) => {

    let _d_prtDats = _get_dat(global.t?.state[pd.state], pd2.ld_adrss); // 参照のみ upd には対応していない

    let _n_lyr = pd2.n_lyr ?? 0;

    let _d_elmDefs = bf.c(
      _od_elmDefsIni({ // 初期値の定義
        elm: pd2.als,
        b_frm: pd2.d_elmDefs.b_frm ?? false
      }), 
      pd2.d_elmDefs || {}
    ); 

    let _ld_elmDatss = pd2.ld_elmDatss; // [] で置き換えた場合、state に値が反映されないことに注意

    return _ld_elmDatss
    .filter( _d_elmDats => { // Pnl の scl 表示制御用
      let _b = (_d_elmDats.b_show != false) ? true : false;
      return _b;
    })
    .filter( _d_elmDats => {
      let _b = _d_elmDefs.ob_vsb ? _d_elmDefs.ob_vsb(_d_elmDats) : _d_elmDefs.b_vsb;
      return _b;
    })
    .map( (_d_dats, _datIdx) => { // elm ごとの処理
      if ( _d_elmDefs.b_hideOnNoCld && _chkNoCld(_d_dats.dld_cldDatsss) ) return null; // 子要素のない親要素は表示しない
      if ( _d_dats.b_dlt == true ) return null;

      let _d_crrAdrs = {
        als: pd2.als, 
        idx: _datIdx
      };
      let _ld_crrAdrss = bf.myCM_copy(pd2.ld_adrss ?? []); // 選択した要素の行番号
      _ld_crrAdrss.push(_d_crrAdrs);

      let _l_cpts = []; // component
      let _n_ttlCnt = (_d_elmDefs.dd_fldDefss) ? ff.myCM_getLen(Object.keys(_d_elmDefs.dd_fldDefss)) : 0;
      let _n_cmnCnt = (_d_elmDefs.d_cmns) ? ff.myCM_cnv('ceil', _n_ttlCnt / _d_elmDefs.d_cmns.n_cnt) : 0;
      let _l_cmnCpts = []; // column component
      if (_d_elmDefs.d_cmns) ff.myCM_getRng(_d_elmDefs.d_cmns.n_cnt ?? 1, 0).map( () => { _l_cmnCpts.push([]) })

      if( !_d_dats.d_flds ) bf.l('5789: WARNING: no d_flds at {}'.f(pd2.als))

      if (_d_elmDefs.dd_fldDefss) Object.keys(_d_elmDefs.dd_fldDefss) // d_flds の場合、歯抜けとなる
      .sort( (_fld1, _fld2) => {
        let _n_sort1 = _d_elmDefs.dd_fldDefss[_fld1].n_sort || 0;
        let _n_sort2 = _d_elmDefs.dd_fldDefss[_fld2].n_sort || 0;
        if ( _n_sort1 > _n_sort2 ) return 1; 
        if ( _n_sort1 < _n_sort2 ) return -1; 
        return 0;
      })
      .map( ( _fld, _fldIdx ) => { // fld ごとの処理
//ff.l('cr 857: {}'.f(_fld))

        let _d_fldDefs = bf.c(
          _od_fldDefsIni({}),
          _d_elmDefs.dd_fldDefss[_fld]
        ); 
        let _type = (_d_fldDefs.o_type) ? _d_fldDefs.o_type(_d_dats) : _d_fldDefs.type;

        let _o = null;

//ff.l('cr 866: {}'.f(_type))
        if (_type == 'Inp') {
          _o = (
            ce.c(ce.Inp, {
              key: 'Inp.{}.{}.{}'.f(pd2.als, _d_dats.key, _fld),
              b_vsb: (_d_fldDefs.ob_vsb) ? _d_fldDefs.ob_vsb(_d_dats) : _d_fldDefs.b_vsb,
              b_edit: (_d_fldDefs.ob_edit) ? _d_fldDefs.ob_edit(_d_dats, _d_prtDats) : _d_fldDefs.b_edit,
              b_tail: _d_fldDefs.b_tail ?? null,
              b_pwd: _d_fldDefs.b_pwd,
              state: null,
              d_ids: null,
              ctlVal: _d_dats.d_flds[_fld] ?? null,
              ini: _d_fldDefs.ini,
              pfx: (_d_elmDefs.b_ttl != false && bf.f(_d_elmDefs.d_cmns) == false) ? _d_fldDefs.pfx : null,
              sfx: (_d_fldDefs.o_sfx) ? _d_fldDefs.o_sfx(_d_dats) : _d_fldDefs.sfx,
              bsd: (_d_fldDefs.o_bsd) ? _d_fldDefs.o_bsd(_d_dats) : _d_fldDefs.bsd,
              phd: _d_fldDefs.phd,
//              d_lbls: pd.d_lbls,
              d_lbls: _d_fldDefs.d_lbls,
              o_onBlurAsCld: _s => { // ios では動作しない模様
                global.t?.setState({
                  [pd.state] : bf.p(global.t?.state[pd.state], _next => {
                    let _d_crrDats = _get_dat(_next, _ld_crrAdrss);
                    _d_crrDats.d_flds[_fld] = _s;
                    if ( bf.f(_d_crrDats.dd_stgss) == false ) _d_crrDats.dd_stgss = {};
                    if ( bf.f(_d_crrDats.dd_stgss[_fld]) == false ) _d_crrDats.dd_stgss[_fld] = {};
                    _d_crrDats.dd_stgss[_fld].b_chg = true;
                    _d_crrDats.b_upd = true; // onChgAsCld の場合、初期化時にフラグが立ってしまう
                    let _d_prtDats = _get_dat(_next, _ld_crrAdrss, true);
                  }),
                }, () => {
                  let _d_crrDats = cf.myRN_getDat(global.t?.state[pd.state], _d_dats.ld_arsss);
                  if (_d_fldDefs.o_onBlur) _d_fldDefs.o_onBlur(_d_crrDats); // o_onChg での call_tree を考慮し immer 後に呼び出し
                });
              },
              o_onChgAsCld: 
                (_d_fldDefs.o_onChg) ?
                  () => {
                    let _d_crrDats = cf.myRN_getDat(global.t?.state[pd.state], _d_dats.ld_arsss);
                    _d_fldDefs.o_onChg(_d_crrDats); // o_onChg での call_tree を考慮し immer 後に呼び出し
                  }
                : null, // re-render を避けるため、onChg の都度、pd.state に値を反映しない方が良い
              o_onFcsAsCld: _d_fldDefs.o_onFcs,
              o_onPrs: 
                ( _d_fldDefs.o_onFldPrs ) ?
                  () => {
                    if ( _d_fldDefs.o_onFldPrs ) _d_fldDefs.o_onFldPrs(_d_dats);
                  }
                : null,
              stlCta: (_d_fldDefs.o_stlCta) ? _d_fldDefs.o_stlCta(_d_dats) : _d_fldDefs.stlCta,
              d_stlCtas: (_d_fldDefs.od_stlCtas) ? _d_fldDefs.od_stlCtas(_d_dats) : _d_fldDefs.d_stlCtas,
              stlInp: (_d_fldDefs.o_stlInp) ? _d_fldDefs.o_stlInp(_d_dats) : (_d_fldDefs.d_stlInps ?? _d_fldDefs.stlInp),
              stlLbl: (_d_fldDefs.o_stlLbl) ? _d_fldDefs.o_stlLbl(_d_dats) : (_d_fldDefs.d_stlLbls ?? _d_fldDefs.stlLbl),
              stlSfx: (_d_fldDefs.o_stlSfx) ? _d_fldDefs.o_stlSfx(_d_dats) : _d_fldDefs.stlSfx,
              o_stlVal: (_d_fldDefs.o_stlVal) ? (() => _d_fldDefs.o_stlVal(_d_dats)) : null,
              n_col: (_d_fldDefs.on_col) ? _d_fldDefs.on_col(_d_dats) : _d_fldDefs.n_col,
              n_row: (_d_fldDefs.on_row) ? _d_fldDefs.on_row(_d_dats) : _d_fldDefs.n_row,
              b_mln: (_d_fldDefs.ob_mln) ? _d_fldDefs.ob_mln(_d_dats) : _d_fldDefs.b_mln,
              n_lyr: _n_lyr,
              aln: _d_fldDefs.aln,
              d_btns: {
                hdrIconName: (_d_dats.b_hideCld == true) ? 'chevron-right' : 'chevron-down',
                o_onHdrPrs: 
                  (_d_fldDefs.b_hdrPrs == true || (bf.f(_d_fldDefs.ob_hdrPrs) && _d_fldDefs.ob_hdrPrs(_d_dats) != false)) ? 
                    _d_ids => {
                      let _dld_cldDatsss = {};
                      Promise.all( // 遅延読込への対応
                        Object.keys(_d_dats.dld_cldDatsss)
                        .map( _als => new Promise( _o_end1 => {
                          if (_d_dats.dld_cldDatsss[_als].b_dly) {
                            _d_dats.dld_cldDatsss[_als].op_call().then( _a_rs => {
                              _dld_cldDatsss[_als] = _a_rs;
                              _o_end1();
                            });
                          }
                          else {
                            _o_end1();
                          };
                        }))
                      )
                      .then(() => {
                        global.t?.setState({
                          [pd.state] : bf.p(global.t?.state[pd.state], _next => {
                            let _d_crrDats = _get_dat(_next, _ld_crrAdrss);
                            if (bf.f(_dld_cldDatsss)) _d_crrDats.dld_cldDatsss = _dld_cldDatsss;
                            _d_crrDats.b_hideCld = (_d_crrDats.b_hideCld) ? false : true;
                          }),
                        });
                      });
                    }
                  : null,
                btnIconName: _d_fldDefs.btnIconName ?? 'plus',
                o_onBtnPrs:
                  (_d_fldDefs.b_btnPrs == true || (_d_fldDefs.ob_btnPrs && _d_fldDefs.ob_btnPrs(_d_dats) != false)) ? 
                    _d_ids => {
                      if (_d_fldDefs.o_onBtnPrs) {
                        _d_fldDefs.o_onBtnPrs(_d_dats);
                      }
                      else {
                        global.t?.setState({
                          [pd.state] : bf.p(global.t?.state[pd.state], _next => { // 子要素の追加
                            let _d_crrDats = _get_dat(_next, _ld_crrAdrss);
                            Object.keys(_d_elmDefs.dd_cldDefss)
                            .map( _als => {
                              let _d_cldDefs = _d_elmDefs.dd_cldDefss[_als];
                              if ( !_d_crrDats.dld_cldDatsss ) _d_crrDats.dld_cldDatsss = {};
                              if ( !_d_crrDats.dld_cldDatsss[_als] ) _d_crrDats.dld_cldDatsss[_als] = [];
                              if ( _d_cldDefs.d_insFlds ) {
                                let _d_insDats = {
                                  ..._od_insDatsIni({
                                    elm: _d_elmDefs.elm,
                                  }),
                                  key: 'new',
                                  b_upd: false,
                                  b_new: true,
                                  b_dlt: false,
                                  d_flds: _d_elmDefs.d_insFlds,
                                  ld_arsss: [
                                    { als: _als, key: 'new', }
                                  ],
                                };
                                _d_crrDats.dld_cldDatsss[_als].push(_d_insDats);
                              };
                              if ( _d_cldDefs.d_insDats ) { // 廃止予定
                                bf.l('cr:935 廃止予定')
                                let _d_insDats = bf.c(
                                  _od_insDatsIni({
                                    elm: _d_cldDefs.elm ?? _als,
                                  }),
                                  _d_cldDefs.d_insDats ?? {}
                                );
                                _d_crrDats.dld_cldDatsss[_als].push(_d_insDats);
                              };
                            });
                          }),
                        });
                      };
                    }
                  : null,
                btnStlCta: _d_fldDefs.btnStlCta,
                o_onDltPrs: 
                  (_d_fldDefs.b_dltPrs == true || (_d_fldDefs.ob_dltPrs && _d_fldDefs.ob_dltPrs(_d_dats) != false)) ? 
                    _d_ids => { // 本要素の削除
                      global.t?.setState({
                        [pd.state] : bf.p(global.t?.state[pd.state], _next => {
                          let _d_crrDats = _get_dat(_next, _ld_crrAdrss);
                          _d_crrDats.b_dlt = true;
                        }),
                      });
                    }
                  : null,
              },
            })
          )
        };

        if ( _type == 'Pck') {
          _o = (
            ce.c(ce.Pck, {
              key: 'Pck.{}.{}.{}'.f(_d_dats.elm, _d_dats.key, _fld),
              b_vsb: (_d_fldDefs.ob_vsb) ? _d_fldDefs.ob_vsb(_d_dats) : _d_fldDefs.b_vsb,
              b_edit: (_d_fldDefs.ob_edit) ? _d_fldDefs.ob_edit(_d_dats, _d_prtDats) : _d_fldDefs.b_edit,
              b_tail: _d_fldDefs.b_tail,
              state: null,
              d_ids: null,
              ctlVal: _d_dats.d_flds[_fld] ?? null,
              ini: _d_fldDefs.ini,
              pfx: (_d_elmDefs.b_ttl != false && bf.f(_d_elmDefs.d_cmns) == false) ? _d_fldDefs.pfx : null,
              bsd: (_d_fldDefs.o_bsd) ? _d_fldDefs.o_bsd(_d_dats) : _d_fldDefs.bsd,
              phd: _d_fldDefs.phd,
              o_onBlur: null, // (_key, _d_items) => {}
//              ld_iss: (_d_fldDefs.o_ld_iss) ? _d_fldDefs.o_ld_iss(_d_dats) : _d_fldDefs.ld_iss,
              ld_iss: (_d_fldDefs.old_iss) ? _d_fldDefs.old_iss(_d_dats) : _d_fldDefs.ld_iss,
              o_onChgAsCld: _d_is => {
                global.t?.setState({
                  [pd.state] : bf.p(global.t?.state[pd.state], _next => {
                    let _d_crrDats = _get_dat(_next, _ld_crrAdrss);
                    _d_crrDats.d_flds[_fld] = _d_is.key;
                    if (bf.f(_d_crrDats.dd_stgss) == false ) _d_crrDats.dd_stgss = {};
                    if (bf.f(_d_crrDats.dd_stgss[_fld]) == false ) _d_crrDats.dd_stgss[_fld] = {};
                    _d_crrDats.dd_stgss[_fld].b_chg = true;
                    _d_crrDats.b_upd = true;
                    _d_crrDats.dd_stgss[_fld].d_rfrs = _d_is; // 廃止予定
                    if (_d_is.als || _d_is.elm) _d_crrDats.d_flds = {
                      [`${_d_is.als ?? _d_is.elm}_key`]: _d_is.d_flds._key,
                      [`${_d_is.als ?? _d_is.elm}_fst`]: _d_is.d_flds._fst,
                      ..._d_is.d_flds,
                      [`_key`]: -1,
                      [`_fst`]: -1,
                      ..._d_crrDats.d_flds,
                    };
                    let _d_prtDats = _get_dat(_next, _ld_crrAdrss, true);
                }),
                }, () => {
                  let _d_crrDats = cf.myRN_getDat(global.t?.state[pd.state], _d_dats.ld_arsss);
                  if (_d_fldDefs.o_onChg) _d_fldDefs.o_onChg(_d_crrDats); // o_onChg での call_tree を考慮し immer 後に呼び出し
                });
              },
              o_onFcsAsCld: _d_fldDefs.o_onFcs,
              stlCta: (_d_fldDefs.o_stlCta) ? _d_fldDefs.o_stlCta(_d_dats) : _d_fldDefs.stlCta,
              stlPfx: (_d_fldDefs.o_stlInp) ? _d_fldDefs.o_stlInp(_d_dats) : (_d_fldDefs.d_stlInps ?? _d_fldDefs.stlInp),
              stlLbl: (_d_fldDefs.o_stlLbl) ? _d_fldDefs.o_stlLbl(_d_dats) : (_d_fldDefs.d_stlLbls ?? _d_fldDefs.stlLbl),
              n_col: (_d_fldDefs.on_col) ? _d_fldDefs.on_col(_d_dats) : _d_fldDefs.n_col,
              n_lyr: _n_lyr,
              d_btns: {
                o_onDltPrs: 
                  (_d_fldDefs.b_dltPrs == true || (_d_fldDefs.ob_dltPrs && _d_fldDefs.ob_dltPrs(_d_dats) != false)) ? 
                    _d_ids => { // 本要素の削除
                      global.t?.setState({
                        [pd.state] : bf.p(global.t?.state[pd.state], _next => {
                          let _d_crrDats = _get_dat(_next, _ld_crrAdrss);
                          _d_crrDats.b_dlt = true;
                        }),
                      });
                    }
                  : null,
//                o_onClrPrs: _d_ids => {
                o_onClrPrsAsCld: _d_ids => {
                  global.t?.setState({
                    [pd.state] : bf.p(global.t?.state[pd.state], _next => {
                      let _d_crrDats = _get_dat(_next, _ld_crrAdrss);
                      _d_crrDats.d_flds[_fld] = -1;
                      if ( bf.f(_d_crrDats.dd_stgss) == false ) _d_crrDats.dd_stgss = {};
                      if ( bf.f(_d_crrDats.dd_stgss[_fld]) == false ) _d_crrDats.dd_stgss[_fld] = {};
                      _d_crrDats.dd_stgss[_fld].b_chg = true;
                      _d_crrDats.b_upd = true; // onChgAsCld の場合、初期化時にフラグが立ってしまう
                      let _d_prtDats = _get_dat(_next, _ld_crrAdrss, true);
                    }),
                  }, () => {
                    let _d_crrDats = cf.myRN_getDat(global.t?.state[pd.state], _d_dats.ld_arsss);
                    if (_d_fldDefs.o_onChg) _d_fldDefs.o_onChg(_d_crrDats);
                  });
                }
              }
            })
          )
        };

        if ( _type == 'PckSch') {
          _o = (
            ce.c(ce.PckSch, {
              key: 'PckSch.{}.{}.{}'.f(_d_dats.elm, _d_dats.key, _fld),
              b_vsb: (_d_fldDefs.ob_vsb) ? _d_fldDefs.ob_vsb(_d_dats) : _d_fldDefs.b_vsb,
              b_edit:  (_d_fldDefs.ob_edit) ? _d_fldDefs.ob_edit(_d_dats, _d_prtDats) : _d_fldDefs.b_edit,
              b_tail: _d_fldDefs.b_tail ?? null,
//              b_tail: true,
              state: null,
              d_ids: null,
              ctlVal: _d_dats.d_flds[_fld] || null,
              ini: _d_fldDefs.ini,
              pfx: (_d_elmDefs.b_ttl != false && bf.f(_d_elmDefs.d_cmns) == false) ? _d_fldDefs.pfx : null,
              bsd: (_d_fldDefs.o_bsd) ? _d_fldDefs.o_bsd(_d_dats) : _d_fldDefs.bsd,
              phd: _d_fldDefs.phd,
              o_onBlur: null, // (_key, _d_items) => {}
              ld_iss: _d_fldDefs.ld_iss,
              o_onChgAsCld:  _d_is => {
//ff.l('1149: {}'.f(_d_is))
                global.t?.setState({
                  [pd.state] : bf.p(global.t?.state[pd.state], _next => {
                    let _d_crrDats = _get_dat(_next, _ld_crrAdrss);
                    _d_crrDats.d_flds[_fld] = _d_is.key;
                    if (bf.f(_d_crrDats.dd_stgss) == false ) _d_crrDats.dd_stgss = {};
                    if (bf.f(_d_crrDats.dd_stgss[_fld]) == false ) _d_crrDats.dd_stgss[_fld] = {};
                    _d_crrDats.dd_stgss[_fld].b_chg = true;
                    _d_crrDats.b_upd = true;
                    _d_crrDats.dd_stgss[_fld].d_rfrs = _d_is;
                    let _d_prtDats = _get_dat(_next, _ld_crrAdrss, true);
                  }),
                }, () => {
//ff.l('1162: {}'.f(_d_is))
                  let _d_crrDats = cf.myRN_getDat(global.t?.state[pd.state], _d_dats.ld_arsss);
                  if (_d_fldDefs.o_onChg) _d_fldDefs.o_onChg(_d_crrDats); // o_onChg での call_tree を考慮し immer 後に呼び出し
                });
              },
              o_onFcsAsCld: _d_fldDefs.o_onFcs,
              stlCta: (_d_fldDefs.o_stlCta) ? _d_fldDefs.o_stlCta(_d_dats) : _d_fldDefs.stlCta,
              stlPfx: (_d_fldDefs.o_stlInp) ? _d_fldDefs.o_stlInp(_d_dats) : (_d_fldDefs.d_stlInps ?? _d_fldDefs.stlInp),
              stlLbl: (_d_fldDefs.o_stlLbl) ? _d_fldDefs.o_stlLbl(_d_dats) : (_d_fldDefs.d_stlLbls ?? _d_fldDefs.stlLbl),
              stlLbl: _d_fldDefs.stlLbl,
//              n_col: _d_fldDefs.n_col,
              n_col: (_d_fldDefs.on_col) ? _d_fldDefs.on_col(_d_dats) : _d_fldDefs.n_col,
              n_lyr: _n_lyr,
              d_btns: {
                o_onClrPrsAsCld: _d_ids => {
                  global.t?.setState({
                    [pd.state] : bf.p(global.t?.state[pd.state], _next => {
                      let _d_crrDats = _get_dat(_next, _ld_crrAdrss);
                      _d_crrDats.d_flds[_fld] = -1;
                      if ( bf.f(_d_crrDats.dd_stgss) == false ) _d_crrDats.dd_stgss = {};
                      if ( bf.f(_d_crrDats.dd_stgss[_fld]) == false ) _d_crrDats.dd_stgss[_fld] = {};
                      _d_crrDats.dd_stgss[_fld].b_chg = true;
                      _d_crrDats.b_upd = true; // onChgAsCld の場合、初期化時にフラグが立ってしまう
                    }),
                  }, () => {
                    let _d_crrDats = cf.myRN_getDat(global.t?.state[pd.state], _d_dats.ld_arsss);
                    if (_d_fldDefs.o_onChg) _d_fldDefs.o_onChg(_d_crrDats);
                  });
                }
              }
            })
          )
        };

        if ( _type == 'PckDate') {
          _o = (
            ce.c(ce.PckDate, {
              key: 'PckDate.{}.{}.{}'.f(_d_dats.elm, _d_dats.key, _fld),
              b_vsb: (_d_fldDefs.ob_vsb) ? _d_fldDefs.ob_vsb(_d_dats) : _d_fldDefs.b_vsb,
              b_edit: (_d_fldDefs.ob_edit) ? _d_fldDefs.ob_edit(_d_dats, _d_prtDats) : _d_fldDefs.b_edit,
              state: null,
              d_ids: null,
              ctlVal: _d_dats.d_flds[_fld] ?? null,
              ini: _d_fldDefs.ini,
              pfx: (_d_elmDefs.b_ttl != false && bf.f(_d_elmDefs.d_cmns) == false) ? _d_fldDefs.pfx : null,
              bsd: (_d_fldDefs.o_bsd) ? _d_fldDefs.o_bsd(_d_dats) : _d_fldDefs.bsd,
              phd: _d_fldDefs.phd,
              o_onBlur: null, // (_key, _d_items) => {}
              ld_iss: _d_fldDefs.ld_iss,
              o_onChgAsCld: _d_is => {
                global.t?.setState({
                  [pd.state] : bf.p(global.t?.state[pd.state], _next => {
                    let _d_crrDats = _get_dat(_next, _ld_crrAdrss);
                    _d_crrDats.d_flds[_fld] = _d_is.key;
                    if (bf.f(_d_crrDats.dd_stgss) == false ) _d_crrDats.dd_stgss = {};
                    if (bf.f(_d_crrDats.dd_stgss[_fld]) == false ) _d_crrDats.dd_stgss[_fld] = {};
                    _d_crrDats.dd_stgss[_fld].b_chg = true;
                    _d_crrDats.b_upd = true;
                    _d_crrDats.dd_stgss[_fld].d_rfrs = _d_is;
                  }),
                }, () => {
                  let _d_crrDats = cf.myRN_getDat(global.t?.state[pd.state], _d_dats.ld_arsss);
                  if (_d_fldDefs.o_onChg) _d_fldDefs.o_onChg(_d_crrDats); // o_onChg での call_tree を考慮し immer 後に呼び出し
                });
              },
              o_onFcsAsCld: _d_fldDefs.o_onFcs,
              stlCta: (_d_fldDefs.o_stlCta) ? _d_fldDefs.o_stlCta(_d_dats) : _d_fldDefs.stlCta,
              stlPfx: (_d_fldDefs.o_stlInp) ? _d_fldDefs.o_stlInp(_d_dats) : (_d_fldDefs.d_stlInps ?? _d_fldDefs.stlInp),
              stlLbl: (_d_fldDefs.o_stlLbl) ? _d_fldDefs.o_stlLbl(_d_dats) : (_d_fldDefs.d_stlLbls ?? _d_fldDefs.stlLbl),
              n_col: (_d_fldDefs.on_col) ? _d_fldDefs.on_col(_d_dats) : _d_fldDefs.n_col,
              n_lyr: _n_lyr,
              d_mdls: _d_fldDefs.d_mdls,
              d_btns: {
                o_onClrPrsAsCld: _d_ids => {
                  global.t?.setState({
                    [pd.state] : bf.p(global.t?.state[pd.state], _next => {
                      let _d_crrDats = _get_dat(_next, _ld_crrAdrss);
                      _d_crrDats.d_flds[_fld] = '';
                      if ( bf.f(_d_crrDats.dd_stgss) == false ) _d_crrDats.dd_stgss = {};
                      if ( bf.f(_d_crrDats.dd_stgss[_fld]) == false ) _d_crrDats.dd_stgss[_fld] = {};
                      _d_crrDats.dd_stgss[_fld].b_chg = true;
                      _d_crrDats.b_upd = true; // onChgAsCld の場合、初期化時にフラグが立ってしまう
                    }),
                  }, () => {
                    let _d_crrDats = cf.myRN_getDat(global.t?.state[pd.state], _d_dats.ld_arsss);
                    if (_d_fldDefs.o_onChg) _d_fldDefs.o_onChg(_d_crrDats);
                });
                }
              }
            }, null)
          );
        };

        if ( _type == 'Chk') {
          _o = (
            ce.c(ce.Chk, {
              key: 'Chk.{}.{}.{}'.f(_d_dats.elm, _d_dats.key, _fld),
              b_vsb: (_d_fldDefs.ob_vsb) ? _d_fldDefs.ob_vsb(_d_dats) : _d_fldDefs.b_vsb,
              b_edit: (_d_fldDefs.ob_edit) ? _d_fldDefs.ob_edit(_d_dats, _d_prtDats) : _d_fldDefs.b_edit,
              frm: 'sqr',
              state: null,
              d_ids: null,
              n_val: _d_dats.d_flds[_fld] ?? null,
              ini: _d_fldDefs.ini,
              pfx: (_d_elmDefs.b_ttl != false && bf.f(_d_elmDefs.d_cmns) == false) ? _d_fldDefs.pfx : null,
              bsd: (_d_fldDefs.o_bsd) ? _d_fldDefs.o_bsd(_d_dats) : _d_fldDefs.bsd,
              phd: _d_fldDefs.phd,
              o_onBlur: null, // (_key, _d_items) => {}
              ld_iss: _d_fldDefs.ld_iss,
              o_onChgAsCld: _n_res => {
//ff.l('1285: {}'.f(_n_res))
                global.t?.setState({
                  [pd.state] : bf.p(global.t?.state[pd.state], _next => {
//                    let _d_crrDats = _get_dat(_next, _ld_crrAdrss);
                    let _d_crrDats = cf.myRN_getDat(_next, _d_dats.ld_arsss);
                    _d_crrDats.d_flds[_fld] = _n_res;
                    if (bf.f(_d_crrDats.dd_stgss) == false ) _d_crrDats.dd_stgss = {};
                    if (bf.f(_d_crrDats.dd_stgss[_fld]) == false ) _d_crrDats.dd_stgss[_fld] = {};
                    _d_crrDats.dd_stgss[_fld].b_chg = true;
                    _d_crrDats.b_upd = true;
                  }),
                }, () => {
                  let _d_crrDats = cf.myRN_getDat(global.t?.state[pd.state], _d_dats.ld_arsss);
                  if (_d_fldDefs.o_onChg) _d_fldDefs.o_onChg(_d_crrDats); // o_onChg での call_tree を考慮し immer 後に呼び出し
                });
              },
              o_onFcsAsCld: _d_fldDefs.o_onFcs,
              d_stlCtas: (_d_fldDefs.od_stlCtas) ? _d_fldDefs.od_stlCtas(_d_dats) : _d_fldDefs.d_stlCtas,
              d_stlPfxs: (_d_fldDefs.od_stlInps) ? _d_fldDefs.od_stlInps(_d_dats) : _d_fldDefs.d_stlInps,
              d_stlLbls: (_d_fldDefs.od_stlLbls) ? _d_fldDefs.od_stlLbls(_d_dats) : _d_fldDefs.d_stlLbls,
              d_stlChks: (_d_fldDefs.od_stlChks) ? _d_fldDefs.od_stlChks(_d_dats) : _d_fldDefs.d_stlChks,
              ccd: (_d_fldDefs.o_ccd) ? _d_fldDefs.o_ccd(_d_dats) : _d_fldDefs.ccd,
              n_col: (_d_fldDefs.on_col) ? _d_fldDefs.on_col(_d_dats) : _d_fldDefs.n_col,
              n_lyr: _n_lyr,
              d_btns: {
                o_onClrPrs: _d_ids => {
                  global.t?.setState({
                    [pd.state] : bf.p(global.t?.state[pd.state], _next => {
                      let _d_crrDats = _get_dat(_next, _ld_crrAdrss);
                      _d_crrDats.d_flds[_fld] = '';
                      if ( bf.f(_d_crrDats.dd_stgss) == false ) _d_crrDats.dd_stgss = {};
                      if ( bf.f(_d_crrDats.dd_stgss[_fld]) == false ) _d_crrDats.dd_stgss[_fld] = {};
                      _d_crrDats.dd_stgss[_fld].b_chg = true;
                      _d_crrDats.b_upd = true; // onChgAsCld の場合、初期化時にフラグが立ってしまう
                    }),
                  }, () => {
                    let _d_crrDats = cf.myRN_getDat(global.t?.state[pd.state], _d_dats.ld_arsss);
                    if (_d_fldDefs.o_onChg) _d_fldDefs.o_onChg(_d_crrDats);
                });
                }
              }
            }, null)
          );
        };

        if ( _type == 'Btn') {
          _o = (
            ce.c(ce.Btn, {
              key: 'Btn.{}.{}.{}'.f(_d_dats.elm, _d_dats.key, _fld),
              b_vsb: (_d_fldDefs.ob_vsb) ? _d_fldDefs.ob_vsb(_d_dats) : _d_fldDefs.b_vsb,
              pfx: _d_fldDefs.pfx,
              o_onPrs: 
                (_d_fldDefs.o_onPrs) ?
                  () => _d_fldDefs.o_onPrs(_d_dats)
                : null,
              d_ctrStls: {
                ..._d_fldDefs.d_ctrStls,
              }
            }, null)
          );
        };

        if (!_d_elmDefs.d_cmns) { // 段組でない場合
          if (_d_fldDefs.od_bdys || _d_fldDefs.d_bdys) {
            _l_cpts.push(
              ce.c(View, {
                key: _fldIdx,
                style: {
                  width: (_d_fldDefs.od_bdys) ? _d_fldDefs.od_bdys(_d_dats).n_w : _d_fldDefs.d_bdys.n_w,
                  height: (_d_fldDefs.od_bdys) ? _d_fldDefs.od_bdys(_d_dats).n_h : (_d_fldDefs.d_bdys?.n_h ?? (ic.g_dvcMode == 's' ? ic.s(2.2) : ic.s(2.2))), 
                  flexDirection: 'row',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                },
              }, [_o])
            );
          }
          else { // セル指定なし
            _l_cpts.push(_o);
          };
        }
        else { // 段組の場合
          let _n_cmn = 
            ((_d_elmDefs.d_cmns.b_hzl ?? true) == true) ?
              _fldIdx % _d_elmDefs.d_cmns.n_cnt
            : ff.myCM_cnv('flr', _fldIdx / _n_cmnCnt);
          _l_cmnCpts[_n_cmn].push(
            ce.c(View, {
              key: `Cmn.Fld.${_fldIdx}`,
              style: {
                height: (_d_fldDefs.od_bdys) ? _d_fldDefs.od_bdys(_d_dats).n_h : (_d_fldDefs.d_bdys?.n_h ?? (ic.g_dvcMode == 's' ? ic.s(2.2) : ic.s(2.2))), 
                flexDirection: 'row',
                justifyContent: 'flex-start',
                alignItems: 'center',
//                alignItems: 'flex-start',
                ..._d_fldDefs.d_stlCmns,
              },
            }, [
//              (_d_fldDefs.b_ttl != false) ?
              (_d_fldDefs.b_ttl != false && (!_d_fldDefs.ob_vsb || _d_fldDefs.ob_vsb(_d_dats))) ?
                ce.c(View, {
                  key: `Cmn.Hdr.${_fldIdx}`,
                  style: {
                    width: _d_fldDefs.d_hdrs?.n_w,
                  },
                }, [
                  ce.c(ce.Lbl, {
                    key: -1,
                    pfx: String(_d_fldDefs.pfx).replace('{n}', `${_datIdx+1}`),
                    d_stlCtas: { // 段組みの lbl の style はここ
                    },
                    d_stlPfxs: { // 段組みの lbl の style はここ
//                      marginTop: ic.s(0.6),
                      ..._d_fldDefs.d_hdrs?.d_stlPfxs ?? null, 
                    },
                    ..._d_fldDefs.d_lbls,
                  })
                ])
              : null,
              ce.c(View, {
                key: `Cmn.Bdy.${_fldIdx}`,
                style: {
                  width: (_d_fldDefs.od_bdys) ? _d_fldDefs.od_bdys(_d_dats).n_w : (_d_fldDefs.d_bdys?.n_w ?? 0),
                },
              }, _o),
            ])
          );
        };

      });

      if (_d_elmDefs.d_cmns) {
        _l_cpts.push(
          ce.c(View, {
            key: 'Cmn.Root',
            style: {
              flexDirection: 'row',
              justifyContent: 'flex-start',
              alignItems: 'flex-start',
            }
          }, 
            _l_cmnCpts.map( (_l_is, _idx) => {
              return ce.c(View, {
                key: `Cmn.Row.${_idx}`, 
                style: {
                  flexDirection: 'column',
                  justifyContent: 'flex-start',
                  alignItems: 'flex-start',
                }
              }, _l_is)
            })
          )
        );
      };

/*
      _l_cpts.push(
        ce.c(View, {
          key: 'Cmn.Root',
          style: {
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
          }
        }, 
          _l_cmnCpts.map( (_l_is, _idx) => {
            return ce.c(View, {
              key: `Cmn.Row.${_idx}`, 
              style: {
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
              }
            }, _l_is)
          })
        )
      );
*/

      if ( _d_elmDefs.b_row == true ) { // データ項目を一行で表示する場合
        _l_cpts = [(
          ce.c(View, {
            key: 'InpTree.{}.{}'.f(_d_dats.elm, _datIdx),
            style: {
              flexDirection: 'row',
              justifyContent: 'flex-start',
              alignItems: 'flex-start',
              backgroundColor: (_d_elmDefs.b_zbr == true && _datIdx % 2 == 0) ? ic.o_getCcd('h') : ic.o_getCcd('b'),
              ...(_d_elmDefs.o_stlRow) ? _d_elmDefs.o_stlRow(_d_dats) : _d_elmDefs.stlRow, // 廃止予定
              ...pd2.d_elmDefs.d_stlBdyRows,
            }
          }, [
            (_d_elmDefs.b_lyr == true) ? // 階層あり
              ce.c(View, {
                key: -1,
                style: {
                  width: _n_lyr * ic.gn_fontSizeNrm,
                },
              })
            : null,
            (_d_elmDefs.b_dlyCld ) ? // hide child の場合　call_tree と InpTree の両方で b_dlyCld を設定
              ce.c(View, {
                key: -2,
                style: {
                  marginTop: 'auto',
                  marginBottom: 'auto',
                  marginLeft: ic.gn_mgnSml,
                  marginRight: ic.gn_mgnSml,
                },
              }, [
                ce.c(ce.BtnIcon, {
                  key : -2,
                  iconName: (_d_dats.b_hideCld == true) ? 'chevron-right' : 'chevron-down',
                  o_onPrs: _d_ids => {
                    let _dld_cldDatsss = {};
                    Promise.all( // 遅延読込への対応
                      Object.keys(_d_dats.dld_cldDatsss)
                      .map( _als => new Promise( _o_end1 => {
                        if (_d_dats.dld_cldDatsss[_als].op_callDlySlc) { // op_callDlySlc は call_tree により自動設定される
                          _d_dats.dld_cldDatsss[_als].op_callDlySlc()
                          .then( _a_rs => {
                            _dld_cldDatsss[_als] = _a_rs;
                            _o_end1();
                          });
                        }
                        else {
                          _o_end1();
                        };
                      }))
                    )
                    .then(() => {
                      global.t?.setState({
                        [pd.state] : bf.p(global.t?.state[pd.state], _next => {
                          let _d_crrDats = _get_dat(_next, _ld_crrAdrss);
                          if (bf.f(_dld_cldDatsss)) _d_crrDats.dld_cldDatsss = _dld_cldDatsss;
                          _d_crrDats.b_hideCld = (_d_crrDats.b_hideCld) ? false : true;
                        }),
                      });
                    });
                  },
                  stlBtn: {
                    backgroundColor: ic.o_getCcd('t'),
                  },
                  stlIcon: {
                    color: ic.o_getCcd('b'),
                  },
                })
              ])
            : null,
            (_d_elmDefs.d_chks?.b_vsb) ? // chk ありの場合
              ce.c(ce.Chk, { 
                key: -3,
                b_val: _d_dats.b_chk ?? _d_elmDefs.d_chks?.b_iniVal,
                b_edit: 
                  (_d_elmDefs.d_chks?.ob_edit) ?
                    _d_elmDefs.d_chks?.ob_edit(_d_dats)
                  : (_d_elmDefs.d_chks?.b_edit != false) ? 
                    true 
                  : false, 
                o_onChg: _b_val => {
                  global.t?.setState({
                    [pd.state] : bf.p(global.t?.state[pd.state], _next => {
                      let _d_crrDats = cf.myRN_getDat(_next, _d_dats.ld_arsss);
                      _d_crrDats.b_chk = _b_val;
                    }),
                  }, () => {
                    if (pd2.d_elmDefs.d_chks.o_onChg) pd2.d_elmDefs.d_chks.o_onChg({ ..._d_dats, b_chk: _b_val });
                  });
                },
              })
            : null,
            ce.c(View, {
              key: -4,
              style: {
                flex: 1,
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                flexWrap: 'wrap',
              }
            }, [
              ce.c(View, {
                key: -4,
                style: {
                  flex: 1,
                  flexDirection: 'row',
                  justifyContent: 'flex-start',
                  alignItems: 'flex-start',
                  flexWrap: 'wrap',
                }
              }, [
                _l_cpts,
                (_d_elmDefs.d_btns?.b_hide || (_d_elmDefs.d_btns?.d_hides && (
                    (_d_elmDefs.d_btns?.d_hides?.ob_vsb) ? 
                      _d_elmDefs.d_btns?.d_hides?.ob_vsb(_d_dats, _d_prtDats) 
                    : (_d_elmDefs.d_btns?.d_hides?.b_vsb) ?
                      _d_elmDefs.d_btns?.d_hides?.b_vsb
                    : false
                  ))) ?  // 子要素を追加
                  ce.c(ce.BtnIconPfx, {
                    key: -5,
                    pfx: (_d_dats.b_hideCld != true) ? '非表示' : '表示　',
                    b_row: true,
                    iconName: _d_elmDefs.d_btns?.d_hides?.iconName ?? '',
                    o_onPrs: () => {
                      cf.myRN_setStt({
                        [pd.state]: _next => {
                          let _d_crrDats = cf.myRN_getDat(_next, _d_dats.ld_arsss);
                          _d_crrDats.b_hideCld = (_d_dats.b_hideCld != true) ? true : false;
                        },
                      })
                    },
                    ccd: ic.o_getCcd('t'),
                    stlCta: {
                      marginTop: 'auto',
                      marginBottom: 0,
                    }
/*
                                  b_vsb: true,
                                  o_pfx: _d_dats => (_d_dats.b_hideCld != true) ? '非表示' : '表示',
                                  o_onPrs: _d_dats => {
                                    cf.myRN_setStt({
                                      'sdld_i1zrDtlsss': _next => {
                                        let _d_crrDats = cf.myRN_getDat(_next, _d_dats.ld_arsss);
                                        _d_crrDats.b_hideCld = (_d_dats.b_hideCld != true) ? true : false;
                                      },
                                    })
                                  },
*/

                  }, [])
                : null,
                (_d_elmDefs.d_btns?.b_cld || (_d_elmDefs.d_btns?.d_clds && (
                    (_d_elmDefs.d_btns?.d_clds?.ob_vsb) ? 
                      _d_elmDefs.d_btns?.d_clds?.ob_vsb(_d_dats, _d_prtDats) 
                    : (_d_elmDefs.d_btns?.d_clds?.b_vsb) ?
                      _d_elmDefs.d_btns?.d_clds?.b_vsb
                    : bf.i(global.t?.state.sgc_pageMode, ['new', 'edit']) ?
                      true
                    : false
                  ))) ?  // 子要素を追加
                  ce.c(ce.BtnIconPfx, {
                    key: -5,
                    pfx: _d_elmDefs.d_btns?.d_clds?.pfx ?? '追加',
                    b_row: true,
                    iconName: 'plus',
                    o_onPrs: () => {
//ff.l('1553: here')
                      global.t?.setState({
                        [pd.state] : bf.p(global.t?.state[pd.state], _next => {
                          let _d_crrDats = cf.myRN_getDat(_next, _d_dats.ld_arsss);
//ff.l('1557: {}, {}'.f(_d_crrDats, _d_dats.ld_arsss))
                          Object.keys(_d_elmDefs.dd_cldDefss)
                          .map( _als => {
                            let _d_cldDefs = _d_elmDefs.dd_cldDefss[_als];
//ff.l('1561: {}'.f(_d_cldDefs))
                            let _key = `now${ff.myCM_gnr(10)}`;
                            let _ld_arsss = ff.myCM_copy(_d_dats.ld_arsss)
                            _ld_arsss.push({ als: _als, key: _key, });
//ff.l('1565: {}'.f(_ld_arsss))
                            if (_d_cldDefs.od_insFlds || _d_cldDefs.d_insFlds) {
//ff.l('1567: here')
                              let _d_insDats = {
                                ..._od_insDatsIni({
                                  elm: _d_cldDefs.elm,
                                }),
                                key: _key,
                                b_upd: false,
                                b_new: true,
                                b_dlt: false,
                                d_flds: (_d_cldDefs.od_insFlds) ? _d_cldDefs.od_insFlds(_d_dats) : _d_cldDefs.d_insFlds,
                                ld_arsss: _ld_arsss,
                              };
                              if (bf.f(_d_crrDats.dld_cldDatsss) == false) _d_crrDats.dld_cldDatsss = {};
                              if (bf.f(_d_crrDats.dld_cldDatsss[_als]) == false) _d_crrDats.dld_cldDatsss[_als] = [];
                              _d_crrDats.dld_cldDatsss[_als].push(_d_insDats);
//ff.l('1582: {}, {}'.f(_als, _d_crrDats.dld_cldDatsss))
                            }
                          });
                        }),
                      }, () => {
//ff.l('1585: {}'.f(global.t?.state[pd.state]))
                      });
                    },
                    ccd: ic.o_getCcd('t'),
                    stlCta: {
                      marginTop: 'auto',
                      marginBottom: 'auto',
                    }
                  }, [])
                : null,
                (_d_elmDefs.d_btns?.b_dlt || (_d_elmDefs.d_btns?.d_dlts && (
                    (_d_elmDefs.d_btns?.d_dlts?.ob_vsb) ? 
                      _d_elmDefs.d_btns?.d_dlts?.ob_vsb(_d_dats, _d_prtDats) 
                    : (_d_elmDefs.d_btns?.d_dlts?.b_vsb) ?
                      _d_elmDefs.d_btns?.d_dlts?.b_vsb
                    : bf.i(global.t?.state.sgc_pageMode, ['new', 'edit']) ?
                      true
                    : false
                  ))) ?   // 削除
                  ce.c(ce.BtnIconPfx, {
                    key: -6,
                    pfx: _d_elmDefs.d_btns?.d_dlts?.pfx ?? '', // 削除は通常 pfx を非表示
                    b_row: true,
                    iconName: 'trash',
                    o_onPrs: () => {
                      global.t?.setState({
                        [pd.state] : bf.p(global.t?.state[pd.state], _next => {
  //                        let _d_crrDats = _get_dat(_next, _ld_crrAdrss);
                          let _d_crrDats = cf.myRN_getDat(_next, _d_dats.ld_arsss);
                          _d_crrDats.b_dlt = true;
                        }),
                      }, () => {
                        let _d_crrDats = cf.myRN_getDat(global.t?.state[pd.state], _d_dats.ld_arsss);
                        if (_d_elmDefs.d_btns?.d_dlts.o_onPrs) _d_elmDefs.d_btns?.d_dlts.o_onPrs(_d_crrDats);
                      });
                    },
                    ccd: ic.o_getCcd('t'),
                    stlCta: {
                      marginTop: 'auto',
                      marginBottom: 'auto',
                    }
                  }, [])
                : null,
              ]),
              (_d_elmDefs.ol_clds) ? // 表示・非表示を切り替え可能な子要素
                _d_elmDefs.ol_clds(_d_dats) 
              : null,
            ])
          ])
        )];
      };

      if ( _d_elmDefs.dd_cldDefss && _d_dats.b_hideCld != true ) {
        Object.keys(_d_elmDefs.dd_cldDefss)
        .map( (_als, _idx) => {
          if (_d_elmDefs.dd_cldDefss && _d_dats.dld_cldDatsss) {
            let _d_cldDefs = _d_elmDefs.dd_cldDefss[_als];
            let _ld_cldDatss = _d_dats.dld_cldDatsss[_als];

            if ( _d_cldDefs.b_subHdr == true) {
              _l_cpts.push(
                ce.c(View, {
                  key: -1,
                  flexDirection: 'row',
                  justifyContent: 'flex-start',
                  alignItems: 'flex-start',
                  style: {
                    ..._d_cldDefs.d_stlSubHdrCtas,
                  },
                }, [
                  _o_rdrHdr({ // subHdr
                    als: _als, // 20211126
                    d_elmDefs: _d_cldDefs,
                    n_lyr: _n_lyr + 1,
                    b_dly: true,
                  })
                ])
              );
            }

/*
            _l_cpts.push(
              ce.c(View, {
                key: _idx,
                style: {
                  ..._d_cldDefs.d_stlSubBdyCtas,
                },
              }, [
                _rdr_tree({
                  als: _als,
                  d_elmDefs: _d_cldDefs, 
                  ld_elmDatss: _ld_cldDatss,
                  ld_adrss: _ld_crrAdrss,
                  n_lyr: _n_lyr + 1,
                })
              ])
            );

            if (_d_cldDefs.d_btns?.b_cld || (_d_cldDefs.d_btns?.d_btrs && ( // 各行に pfx が表示され、いけてない
                (_d_cldDefs.d_btns?.d_btrs?.ob_vsb) ? 
                  _d_cldDefs.d_btns?.d_btrs?.ob_vsb(_d_dats, _d_prtDats) 
                : (_d_cldDefs.d_btns?.d_btrs?.b_vsb) ?
                  _d_cldDefs.d_btns?.d_btrs?.b_vsb
                : bf.i(global.t?.state.sgc_pageMode, ['new', 'edit']) ?
                  true
                : false
              ))) {  // 子要素を追加
                _l_cpts.push(
                  ce.c(ce.BtnIconPfx, {
                    key: -5,
                    pfx: _d_cldDefs.d_btns?.d_btrs?.pfx ?? '追加',
                    b_row: true,
                    iconName: 'plus',
                    o_onPrs: () => {
                      if (_d_cldDefs.od_insFlds || _d_cldDefs.d_insFlds) {
                        cf.myRN_setStt({
                          [pd.state] : _next => {
                            let _d_crrDats = cf.myRN_getDat(_next, _d_dats.ld_arsss);
                            let _key = `new${ff.myCM_gnr(10)}`;
                            let _ld_arsss = ff.myCM_copy(_d_crrDats.ld_arsss);
                            _ld_arsss.push({ als: _als, key: _key });
                            let _d_insDats = {
                              ..._od_insDatsIni({
                                elm: _d_cldDefs.elm,
                              }),
                              key: _key,
                              b_upd: false,
                              b_new: true,
                              b_dlt: false,
                              d_flds: (_d_cldDefs.od_insFlds) ? _d_cldDefs.od_insFlds(_d_dats) : _d_cldDefs.d_insFlds,
                              ld_arsss: _ld_arsss,
                            };
                            if (bf.f(_d_crrDats.dld_cldDatsss) == false) _d_crrDats.dld_cldDatsss = {};
                            if (bf.f(_d_crrDats.dld_cldDatsss[_als]) == false) _d_crrDats.dld_cldDatsss[_als] = [];
                            _d_crrDats.dld_cldDatsss[_als].push(_d_insDats);
                          },
                        });
                      }
                      else {
                        alert('cr 1534: od_insFlds または d_insFlds が定義されていません');
                      };
                    },
                    ccd: ic.o_getCcd('t'),
                    stlCta: {
                      marginTop: 'auto',
                      marginBottom: 'auto',
                      marginLeft: ic.s(1),
                      ..._d_cldDefs.d_btns.d_btrs.d_stlCta,
                    }
                  }, [])
                );
            };
*/
            let _l = [];
            _l.push(
              _rdr_tree({
                als: _als,
                d_elmDefs: _d_cldDefs, 
                ld_elmDatss: _ld_cldDatss,
                ld_adrss: _ld_crrAdrss,
                n_lyr: _n_lyr + 1,
              })
            );

            if (_d_cldDefs.d_btns?.b_cld || (_d_cldDefs.d_btns?.d_btrs && ( // 各行に pfx が表示され、いけてない
                (_d_cldDefs.d_btns?.d_btrs?.ob_vsb) ? 
                  _d_cldDefs.d_btns?.d_btrs?.ob_vsb(_d_dats, _d_prtDats) 
                : (_d_cldDefs.d_btns?.d_btrs?.b_vsb) ?
                  _d_cldDefs.d_btns?.d_btrs?.b_vsb
                : bf.i(global.t?.state.sgc_pageMode, ['new', 'edit']) ?
                  true
                : false
              ))) {  // 子要素を追加
                _l.push(
                  ce.c(ce.BtnIconPfx, {
                    key: -5,
                    pfx: _d_cldDefs.d_btns?.d_btrs?.pfx ?? '追加',
                    b_row: true,
                    iconName: 'plus',
                    o_onPrs: () => {
                      if (_d_cldDefs.od_insFlds || _d_cldDefs.d_insFlds) {
                        cf.myRN_setStt({
                          [pd.state] : _next => {
                            let _d_crrDats = cf.myRN_getDat(_next, _d_dats.ld_arsss);
                            let _key = `new${ff.myCM_gnr(10)}`;
                            let _ld_arsss = ff.myCM_copy(_d_crrDats.ld_arsss);
                            _ld_arsss.push({ als: _als, key: _key });
                            let _d_insDats = {
                              ..._od_insDatsIni({
                                elm: _d_cldDefs.elm,
                              }),
                              key: _key,
                              b_upd: false,
                              b_new: true,
                              b_dlt: false,
                              d_flds: (_d_cldDefs.od_insFlds) ? _d_cldDefs.od_insFlds(_d_dats) : _d_cldDefs.d_insFlds,
                              ld_arsss: _ld_arsss,
                            };
                            if (bf.f(_d_crrDats.dld_cldDatsss) == false) _d_crrDats.dld_cldDatsss = {};
                            if (bf.f(_d_crrDats.dld_cldDatsss[_als]) == false) _d_crrDats.dld_cldDatsss[_als] = [];
                            _d_crrDats.dld_cldDatsss[_als].push(_d_insDats);
                          },
                        });
                      }
                      else {
                        alert('cr 1534: od_insFlds または d_insFlds が定義されていません');
                      };
                    },
                    ccd: ic.o_getCcd('t'),
                    stlCta: {
                      marginTop: 'auto',
                      marginBottom: 'auto',
                      marginLeft: ic.s(1),
                      ..._d_cldDefs.d_btns.d_btrs.d_stlCta,
                    }
                  }, [])
                );
            };

            _l_cpts.push(
              ce.c(View, {
                key: _idx,
                style: {
                  ..._d_cldDefs.d_stlSubBdyCtas,
                },
              }, _l)
            );

          };
        });
      };

/*
      if (_d_elmDefs.d_btns?.b_cld || (_d_elmDefs.d_btns?.d_btrs && ( // 各行に pfx が表示され、いけてない
          (_d_elmDefs.d_btns?.d_btrs?.ob_vsb) ? 
            _d_elmDefs.d_btns?.d_btrs?.ob_vsb(_d_dats, _d_prtDats) 
          : (_d_elmDefs.d_btns?.d_btrs?.b_vsb) ?
            _d_elmDefs.d_btns?.d_btrs?.b_vsb
          : bf.i(global.t?.state.sgc_pageMode, ['new', 'edit']) ?
            true
          : false
        ))) {  // 子要素を追加
          _l_cpts.push(
            ce.c(ce.BtnIconPfx, {
              key: -5,
              pfx: _d_elmDefs.d_btns?.d_btrs?.pfx ?? '追加',
              b_row: true,
              iconName: 'plus',
              o_onPrs: () => {
                if (_d_elmDefs.od_insFlds || _d_elmDefs.d_insFlds) {
                  cf.myRN_setStt({
                    [pd.state] : _next => {
                      let _d_prtDats = cf.myRN_getDat(_next, _d_dats.ld_arsss, true);
                      let _key = `new${ff.myCM_gnr(10)}`;
                      let _ld_arsss = ff.myCM_copy(_d_prtDats.ld_arsss);
                      _ld_arsss.push({ als: pd2.als, key: _key });
                      let _d_insDats = {
                        ..._od_insDatsIni({
                          elm: _d_elmDefs.elm,
                        }),
                        key: _key,
                        b_upd: false,
                        b_new: true,
                        b_dlt: false,
                        d_flds: (_d_elmDefs.od_insFlds) ? _d_elmDefs.od_insFlds(_d_dats) : _d_elmDefs.d_insFlds,
                        ld_arsss: _ld_arsss,
                      };
                      if (bf.f(_d_prtDats.dld_cldDatsss) == false) _d_prtDats.dld_cldDatsss = {};
                      if (bf.f(_d_prtDats.dld_cldDatsss[pd2.als]) == false) _d_prtDats.dld_cldDatsss[pd2.als] = [];
                      _d_prtDats.dld_cldDatsss[pd2.als].push(_d_insDats);
                    },
                  });
                }
                else {
                  alert('cr 1534: od_insFlds または d_insFlds が定義されていません');
                };
              },
              ccd: ic.o_getCcd('t'),
              stlCta: {
                marginTop: 'auto',
                marginBottom: 'auto',
              }
            }, [])
          );
      };
*/

      return _l_cpts;

    });
  };

  let _r = [];
  
  Object.keys(global.t?.state[pd.state])
  .map( async (_als, _alsIdx) => {

    if (bf.f(pd.dd_elmDefss[_als]) == false) {
      alert('{} is not defined at {}'.f(_als, pd.state));
    };

    let _d_elmDefs = bf.c(
      _od_elmDefsIni({
        elm: _als,
        b_frm: pd.dd_elmDefss[_als].b_frm ?? false,
      }), 
      pd.dd_elmDefss[_als] ?? {}
    ); 

    let _l_hdrs = [];

    if (_d_elmDefs.b_rootHdr) { // 見出しを表示する場合
      _l_hdrs = _o_rdrHdr({
        als: _als, // 20211126
        d_elmDefs: _d_elmDefs,
      })
    };

    let _ld_elmDatss = global.t?.state[pd.state][_als];
    let _r2 = _rdr_tree({
      als: _als,
      d_elmDefs: _d_elmDefs,
      ld_elmDatss: _ld_elmDatss,
    });


    _r.push(
      ce.c(View, {
        key: 'InpTree.root',
        style: {
          width: pd.n_w,
          height: pd.n_h,
          marginTop: pd.n_mgnTop,
          marginBottom: pd.n_mgnBtm,
          marginLeft: pd.n_mgnLeft,
          marginRight: pd.n_mgnRht,
          paddingTop: pd.n_pdgTop,
          paddingBottom: pd.n_pdgBtm,
          paddingLeft: pd.n_pdgLeft,
          paddingRight: pd.n_pdgRht,
          maxHeight: '100%',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'center',
          ...pd.d_stlCtas,
        },
      }, [
        ce.c(View, {
          key: -1,
          style: {
            maxHeight: '100%',
          },
        }, [
          ce.c(ce.Lbl, {
            key: -1,
            b_vsb: bf.f(_d_elmDefs.pfx) ? true : false,
            pfx: _d_elmDefs.pfx,
            d_btns: _d_elmDefs.d_btns?.d_lbls ?? null,
          }, []),
          ce.c(View, {
            key: -2,
            style: {
              ...ic.od_stls().d_rootHdrCtas,
              ..._d_elmDefs.d_stlRootHdrCtas,
            },
          }, [
            _l_hdrs,
          ]),
          ce.c(ScrollView, {
            key: -3,
            style: [{
              flex: 1,
            }],
            contentContainerStyle: {
              ...ic.od_stls().d_rootBdyCtas,
              ..._d_elmDefs.d_stlRootBdyCtas,
            },
          }, [
            (_d_elmDefs.b_hzl) ? 
              ce.c(View, {
                key: -2,
                style: {
                  flexDirection: 'row',
                  justifyContent: 'flex-start',
                  alignItems: 'flex-start',
                  flexWrap: 'wrap',
                }, 
              }, [_r2])
            : _r2
          ])

        ])
      ])
    );
  })

  return _r;
}

};
/*
 Copyright 2020 Yukio Shinohara All rights reserved.
 */
